import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import NavBar from '../components/NavBar'
import EmailSignupButton from '../components/EmailSignupButton'
import TestimonialBanner from '../components/TestimonialBanner'
import FeaturesSection from '../components/FeaturesSection'
import VerticalMissions from '../components/VerticalMissions'
import FaqSection from '../components/FaqSection'
import Footer from '../components/Footer'
import './home.css'

const Home = (props) => {
  const location = useLocation()
  const [highlightedFeature, setHighlightedFeature] = useState(null);

  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo)
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' })
        }, 100)
      }
    }
  }, [location])

  // Function to handle feature highlighting
  const highlightFeature = (featureId) => {
    setHighlightedFeature(featureId === highlightedFeature ? null : featureId);
  };

  // Define the base URL for assets - should point to the public folder
  const publicUrl = process.env.PUBLIC_URL || '';

  return (
    <div className="home-container10">
      <Helmet>
        <title>block automation</title>
        <meta property="og:title" content="Block Automation" />
        <meta property="og:description" content="block better." />
        <meta property="og:image" content="/Block Logo-01.png" />
      </Helmet>
      <NavBar />
      
      {/* Full-page-width landing section */}
      <div className="landing-section full-width" style={{ 
        backgroundImage: `url(${publicUrl}/landing_lq.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}>
        <div className="landing-content">
          <span className="small-label">COMING SOON</span>
          <h1 className="main-headline">A new way to sunscreen</h1>
          <p className="main-description" style={{ color: '#1C3D49' }}>
          The world's most innovative automatic sunscreen dispenser. <br></br> <strong style={{ color: '#FBB040' }}>Sun Blocks</strong> by Block Automation are compact, robust and provide high-quality sunscreen at any outdoor location. No waste, no hassle.
          </p>
          <div className="buttons-container">
            <button 
              className="button button-primary"
              onClick={() => window.location.href = '/partners'}
            >
              Get started
            </button>
            <EmailSignupButton className="landing-signup" />
          </div>
        </div>
      </div>
      
      <TestimonialBanner />
      
      {/* Features Section - Now a separate component */}
      <FeaturesSection />
      
      <div className="home-section2 section-container">
        <div className="home-max-width4 max-width">
          <div className="home-content3">
            <span className="home-text35 beforeHeading">Quality Sunscreen Solution</span>
            <h1 className="home-text36">
              <span className="home-text37">Enhance your venue.</span>
              <br></br>
              <span className="home-text39">
                Provide sun protection as a valuable amenity for your patrons.
              </span>
            </h1>
            <span className="home-text40">
                 
             <span className="home-text44"><strong style={{ color: '#FBB040' }}>Sun Block</strong></span> dispensers are stocked with 30 SPF broad spectrum moisturizing sunscreen.  Increase customer satisfaction, extend their stay, and boost your revenue while showing you care about their health and safety.
            </span>
            <div className="home-container13">
              <button 
                className="mission-card-button"
                onClick={() => window.location.href = '/partners'}
              >
                Get started
              </button>
            </div>
          </div>
          <img
            alt="image"
            src="/hands.jpg"
            className="home-hero-image3"
          />
          <div className="home-image6"></div>
        </div>
      </div>
     
      {/* Replace the mission section with our new VerticalMissions component */}
      <VerticalMissions />
      
      {/* Use the new FaqSection component */}
      <FaqSection />
      
      <div className="facts-cta-section section-container">
        <div className="max-width">
          <div className="cta-banner">
            <span className="beforeHeading">Clean, Reliable and Approachable</span>
            <h2><span className="home-text44"><strong style={{ color: '#FBB040' }}>Sun Blocks</strong></span></h2>
            <p>
              Contact us today to schedule a demo or book a call to see how <strong style={{ color: '#FBB040' }}>Sun Blocks</strong> can enhance your venue.
            </p>
            <div className="cta-buttons">
              <button 
                className="button button-primary"
                onClick={() => window.location.href = '/contact'}
              >
                Schedule a demo
              </button>
              <EmailSignupButton />
            </div>
          </div>
        </div>
      </div>
     
      {/* Replace the old footer with the new Footer component */}
      <Footer />
    </div>
  )
}

export default Home
